import { useCallback, useEffect, useState } from 'react';
import { ensureTrailingSlash } from './url/url';
export { default as Rest } from './rest/rest';

export const baseURL = ensureTrailingSlash(process.env.REACT_APP_API_URL);

export const useAsyncApi = (fetch) => {
  const [isLoading, setLoading] = useState(true);
  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const reload = useCallback(() => setCount((c) => c + 1));

  useEffect(() => {
    (async () => {
      if (!fetch) {
        return;
      }

      try {
        setLoading(true);
        setError(undefined);
        const response = await fetch();
        setResponse(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [fetch, count]);

  return { isLoading, response, error, reload };
};
